module.exports = __webpack_public_path__ + "img/656662_9B9B99_393B31_8B8C8C-256px.6c660bc6.png";